import { useEffect, useState } from 'react';
import { RegisterImplementationProps } from 'constants/types';
import { EMPLOYER_PREFIX } from 'constants/products';
import { Scopes } from 'constants/scopes';
import SignInPaycomCredential from './SignInPaycomCredential';
import PaycomSyncCloneCheck from './PaycomSyncCloneCheck';
import SignInBase from '../SignInBase';
import { getProviderFormLabel } from '../utils';
import { useSignInShellHeader } from 'store/sign-in-shell-header';

const PAYMENT_SCOPES: string[] = [Scopes.Payment, Scopes.Pay_Statement];

const SignInPaycomCredentialWithCheck = (
  props: RegisterImplementationProps,
) => {
  const hasPaymentScope = props.products.some(
    (product) =>
      PAYMENT_SCOPES.includes(product) ||
      PAYMENT_SCOPES.includes(`${EMPLOYER_PREFIX}${product}`),
  );
  const [hasConfirmedSyncClone, setHasConfirmedSyncClone] = useState(false);
  const setSuppressConnectTitle = useSignInShellHeader(
    (state) => state.setSuppressConnectTitle,
  );
  const setGoBackOverride = useSignInShellHeader(
    (state) => state.setGoBackOverride,
  );

  const showChecklist = hasPaymentScope && !hasConfirmedSyncClone;

  useEffect(() => {
    setSuppressConnectTitle(showChecklist);
    return () => setSuppressConnectTitle(false);
  }, [showChecklist, setSuppressConnectTitle]);

  useEffect(() => {
    if (hasConfirmedSyncClone) {
      setGoBackOverride(() => setHasConfirmedSyncClone(false));
      return () => setGoBackOverride(null);
    }
    return undefined;
  }, [hasConfirmedSyncClone, setGoBackOverride]);

  if (showChecklist) {
    return (
      <SignInBase formLabel={getProviderFormLabel(props.provider)}>
        <PaycomSyncCloneCheck
          onContinue={() => setHasConfirmedSyncClone(true)}
        />
      </SignInBase>
    );
  }

  return <SignInPaycomCredential {...props} />;
};

export default SignInPaycomCredentialWithCheck;
